import memoize from 'lru-memoize';
import { createValidator, required, oneOf, minLength } from '../../utils/validation';
import { contractTypesAll } from '../../constants/contractType';

const validation = createValidator({
  templateType: [required, oneOf(contractTypesAll)],
  state: [required],
  lenderMatch: [minLength(3)],
  language: [required, oneOf(['english', 'spanish'])],
});

export default memoize(10)(validation);
